import { Directive } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { DynamicReportGeneralDto, DynamicReportGeneralModel, IDynamicReportGeneral, PreviewDynamicReportDto } from '@shared/components/dynamic-report-general';
import { ExceljsCard, ExceljsFileSupportedConfig, ExceljsWorkBook } from '@shared/components/exceljs-viewer';

import { isObject } from 'lodash-es';
import { Observable, map, of } from 'rxjs';

export enum DynamicReportCollection {
  DynamicReport = 'storage/dynamic-reports',
  ProjectReport = 'storage/dynamic-reports/project',
  ResaleReport = 'storage/dynamic-reports/resale',

}
@Directive()
export abstract class DynamicReportApiService {
  static ROOT_POINT = 'storage/dynamic-reports';
  abstract collectionEndpoint: DynamicReportCollection;

  constructor(protected apiService: ApiService) { }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<DynamicReportGeneralModel>> {
    return this.apiService.get(this.collectionEndpoint, query, option).pipe(map(data => new PaginationAdapter(DynamicReportGeneralModel, data)));
  }

  get(id: number, query = {}, option?: IApiOption): Observable<DynamicReportGeneralModel> {
    return this.apiService.get(this.collectionEndpoint + '/' + id, query, { ...option, removeEmpty: { enable: true } }).pipe(map(res => DynamicReportGeneralModel.fromJson(res) as DynamicReportGeneralModel));
  }

  getDynamicReportMeta(type: string, query = {}): Observable<DynamicReportGeneralModel> {
    return this.apiService.get(DynamicReportApiService.ROOT_POINT + '/' + type + '/' + 'metadata', query).pipe(map(res => DynamicReportGeneralModel.fromJson(res) as DynamicReportGeneralModel));
  }

  createDynamicReportPreview(id: number, data: PreviewDynamicReportDto): Observable<ExceljsWorkBook> {
    return this.apiService.post(DynamicReportApiService.ROOT_POINT + '/' + data.reportType + '/' + id + '/' + 'preview', data).pipe(map(res => ExceljsWorkBook.fromJson(res) as ExceljsWorkBook));
  }

  create(data: DynamicReportGeneralDto): Observable<DynamicReportGeneralModel> {
    return this.apiService
      .post(DynamicReportApiService.ROOT_POINT + '/' + data.reportType, data)
      .pipe(map((res: IDynamicReportGeneral) => DynamicReportGeneralModel.fromJson(res) as DynamicReportGeneralModel));
  }

  update(id: number, data: DynamicReportGeneralDto): Observable<DynamicReportGeneralModel> {
    return this.apiService
      .patch(DynamicReportApiService.ROOT_POINT + '/' + data.reportType + '/' + id, data, { excludeFields: [''] });
  }

  delete(id: number): Observable<any> {
    return this.apiService.delete(this.collectionEndpoint + '/' + id);
  }

  getDynamicReportXlsxFile(id: number, data: DynamicReportGeneralDto): Observable<any> {
    return this.apiService
      .post(
        DynamicReportApiService.ROOT_POINT + '/' + data.reportType + '/' + id + '/download',
        { ...data, type: 'xlsx' },
        {
          pretreatmentResponse: false,
          requestOptions: {
            responseType: 'arraybuffer',
          },
        }
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getDynamicReportCard(code: string, query = {}): Observable<ExceljsCard> {
    return this.apiService.get(this.collectionEndpoint + '/' + code, query).pipe(map(res => ExceljsCard.fromJson(res) as ExceljsCard));
  }

  queryDynamicReportCard(code: string, data: Record<string, any>): Observable<ExceljsWorkBook> {
    return this.apiService.post(this.collectionEndpoint + '/' + code, data).pipe(map(res => ExceljsWorkBook.fromJson(res) as ExceljsWorkBook));
  }

  getDynamicReportCardXlsxFile(code: string, data: Record<string, any> = {}, extConfig?: string | ExceljsFileSupportedConfig): Observable<any> {
    const ext = isObject(extConfig) ? extConfig.type : extConfig;
    const isStream = isObject(extConfig) ? extConfig.stream : false;
    return this.apiService.download('post', this.collectionEndpoint + '/' + code + '/download',
      { ...data, type: ext ?? 'xlsx', tream: isStream }, isStream)
    // return this.apiService
    //   .post(
    //     this.collectionEndpoint + '/' + code + '/download',
    //     { ...data, type: ext ?? 'xlsx' },
    //     {
    //       pretreatmentResponse: false,
    //       requestOptions: {
    //         responseType: 'arraybuffer',
    //       },
    //     }
    //   )
    //   .pipe(
    //     map(res => {
    //       return res;
    //     })
    //   );
  }

}
